import { Button, Flex } from "@mantine/core";
import { OrderList } from "../OrderList/OrderList";
import { IconDownload, IconFileDownload } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";
import classes from "./ProfileContent.module.css";

export default function ProfileContent(): React.JSX.Element {
  const { t } = useTranslation("translation");
  return (
    <>
      <Flex
        className={classes.flexContainer}
        direction={{ base: 'column', sm: 'row' }}
        gap={{ base: 'sm', sm: 'lg' }}
        justify={{ sm: 'center' }}
      >
        <Button variant="gradient" component="a" href="https://irdrive.accsolutions.de/release/IR%20DRIVE%20Setup.exe"
                gradient={{ from: "#1369EF", to: "#004aba" }}
                size="md" className={classes.control}>{t("general.downloadDrive")}<IconDownload /></Button>
        <Button variant="gradient" component="a" href="https://docs.google.com/document/d/1HAUmjEJXcv4iDG2AZyoeObLBCEcbann3CTJCKk2dw6Y/export?format=pdf"
                gradient={{ from: "#1369EF", to: "#004aba" }}
                size="md" className={classes.control}>{t("general.downloadManual")}<IconFileDownload /></Button>
      </Flex>
      {process.env.NODE_ENV === 'development' ? (
        <OrderList />
      ) : (
        <OrderList />
      )}
    </>
  );
}
